import React from 'react'
import { Link } from 'react-router-dom'
import { useRouteMatch } from 'react-router'
import { Helmet } from 'react-helmet'
import { get } from 'lodash'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'
import Icon from 'components/Icon'
import './index.scss' // Must be imported after Icon due to CSS ordering
import useSession from 'hooks/useSession'

const bem = new BEMHelper('booking-header')

export default function Header({ title, seoTitle, children, seoDescription, link = '/' }) {
  const ouSlug = useRouteMatch('/:ouSlug')?.params?.ouSlug ?? ''
  const { isSignedIn, clearSession, session } = useSession()
  const name = `${get(session, 'first_name', '')} ${get(session, 'last_name', '')}`

  return (
    <>
      {(title || seoTitle) && (
        <Helmet>
          <title>{title || seoTitle} | Remin</title>
          {seoDescription && <meta name="description" content={seoDescription} />}
        </Helmet>
      )}

      <header {...bem('')}>
        <Link to={link} {...bem('item', 'brand')}>
          {title || 'Remin'}
        </Link>

        {children && <span {...bem('item')}>{children}</span>}

        <div {...bem('separator')} />

        {isSignedIn && <span {...bem('item', 'name')}>{name}</span>}

        {isSignedIn ? (
          <button
            type="button"
            {...bem('logout')}
            aria-label="Logg ut"
            onClick={() => clearSession(`/${ouSlug}`)}
          >
            <Icon icon="x" />
          </button>
        ) : null}
      </header>
    </>
  )
}

Header.propTypes = {
  title: T.string,
  seoTitle: T.string,
  seoDescription: T.string,
  children: T.any,
  link: T.string,
  clearSessionData: T.oneOfType([T.string, T.object]),
}
